import { Pipe, PipeTransform } from '@angular/core';
import { ScTableColumn } from '../../../../models/table.model';

@Pipe({
  name: 'columnName'
})
export class ColumnNamePipe implements PipeTransform {
  transform(col: ScTableColumn): unknown {
    if (typeof col.prop === 'function') {
      return col.name.toLowerCase().replace(' ', '_');
    }
    return col.prop;
  }
}
